import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { ProgressBar } from 'settle-ui/components/ProgressBar/ProgressBar'
import { useOnboardingLayoutContext } from '../../../../hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import { getOnboardingProgressValue } from './helpers/getOnboardingProgressValue/getOnboardingProgressValue'
import type { BusinessTypeEnum } from 'gql/types'

export interface OnboardingProgressBarProps {
  businessType: BusinessTypeEnum
}

export const OnboardingProgressBar: Settle.FC<OnboardingProgressBarProps> = ({ businessType, ...props }) => {
  const minimumRenderedValue = 12
  const { pathname } = useRouter()
  const { isSimplifiedFlow, interestedIn } = useOnboardingLayoutContext()
  const { current, prev } = getOnboardingProgressValue({ pathname, businessType, isSimplifiedFlow, interestedIn })
  const [value, setValue] = useState(prev >= minimumRenderedValue ? prev : minimumRenderedValue)

  useEffect(() => {
    setValue(current)
  }, [current])

  return <ProgressBar {...props} value={value} variant="determinate" />
}
